import { HaNContext, HaNDetailsContext, HaNSearchContext } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { PanelStack } from "../../shared/PanelStack/PanelStack";
import { PersonInfoPage } from "./PersonInfoPage";

export const PersonDetails = () => {
  const { selection } = useRequiredContext(HaNDetailsContext);
  const { people } = useRequiredContext(HaNContext);
  const { searchedPeople } = useRequiredContext(HaNSearchContext);

  if (selection.kind !== "person") return null;

  // Looks the person up among everyone in the building today, so a floor change doesn't close their details
  const reservations = people.reservations
    .filter(r => r.owner.id === selection.id)
    .toSorted((a, b) => a.localStart.localeCompare(b.localStart));

  // Someone the search found who isn't in the building today
  const person = reservations[0]?.owner ?? searchedPeople.get(selection.id);

  if (!person) return null;

  return (
    <PanelStack initial="info">
      <PanelStack.Page pageId="info">
        <PersonInfoPage
          person={person}
          reservations={reservations}
          selectedNodeId={selection.nodeId}
        />
      </PanelStack.Page>
    </PanelStack>
  );
};
